module.exports = __webpack_public_path__ + "static/media/535357_3605771669661_602689446_n.dece70eb.jpg";